var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWaterIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 67,
    viewBox: "0 0 58 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.7413 0.485838C37.7413 0.485767 37.7425 0.486227 37.7451 0.487433C37.7426 0.486513 37.7413 0.485909 37.7413 0.485838ZM37.828 0.54021C37.875 0.574516 37.9353 0.623845 38.0096 0.691752C38.2156 0.880036 38.4843 1.16975 38.8104 1.55973C39.4602 2.33681 40.3014 3.46803 41.2687 4.87036C43.2015 7.67256 45.6168 11.5267 47.978 15.724C50.3395 19.922 52.6413 24.4535 54.3512 28.6115C56.0684 32.7873 57.162 36.5246 57.162 39.1579C57.1619 41.6965 56.6619 44.2102 55.6903 46.5555C54.7188 48.9008 53.2948 51.0318 51.4997 52.8268C47.8744 56.452 42.9574 58.4885 37.8305 58.4884C32.7036 58.4883 27.7868 56.4515 24.1616 52.8261C20.5364 49.2008 18.4999 44.2838 18.5 39.1569C18.5 36.5238 19.5936 32.7842 21.3109 28.6054C23.0208 24.4444 25.3226 19.9093 27.6841 15.7089C30.0453 11.5092 32.4605 7.65397 34.3933 4.85378C35.3605 3.45241 36.2016 2.32312 36.8511 1.54901C37.1771 1.16046 37.4454 0.87276 37.6508 0.686737C37.7232 0.62112 37.782 0.573443 37.828 0.54021ZM37.9106 0.488058C37.9135 0.486662 37.915 0.486143 37.915 0.486233C37.9149 0.486322 37.9134 0.48702 37.9106 0.488058Z",
    stroke: "#7DD8E9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_581_11376)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.7109 46.5696C24.6924 47.1754 27.2108 44.6833 28.3359 41.0034C29.4609 37.3235 28.7666 33.8492 26.7851 33.2434C24.8036 32.6376 22.2852 35.1296 21.1602 38.8096C20.0351 42.4895 20.7294 45.9638 22.7109 46.5696Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_581_11376",
    x: 0.621094,
    y: 13.1528,
    width: 48.2539,
    height: 53.5073,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "effect1_foregroundBlur_581_11376"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterIcon);
export default __webpack_public_path__ + "static/media/WaterIcon.04d0cc8e9b91849c9158bf3f9bd92a03.svg";
export { ForwardRef as ReactComponent };